export default class TrackCommentPanelVisibility {
  constructor(context) {
    this.context = context;
  }

  run({ itemId, isVisible }) {
    if (isVisible) {
      this.context.analytics.track('Comment Panel Opened', {
        itemId,
      });
    } else {
      this.context.analytics.track('Comment Panel Closed', {
        itemId,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/task/track_comment_panel_visibility.js